import { useQueryAppInfo } from "src/queries/info/info.query";
import { useGlobalLocalContext } from "src/storage/localStorage";
import now from "~build/time";

// Git metadata is injected at build time via build args (see frontend/Dockerfile
// + scripts/docker/build_docker.sh) so the image build stays hermetic and does
// not need the repo's .git. Empty when building outside that flow (e.g. `yarn dev`).
const branch = import.meta.env.VITE_GIT_BRANCH;
const abbreviatedSha = import.meta.env.VITE_GIT_SHA;
const committerDate = import.meta.env.VITE_GIT_COMMIT_DATE;

const DebugInfo = () => {
  const isDebugMode = useGlobalLocalContext((state) => state.isDebugMode);
  const appInfo = useQueryAppInfo();

  return (
    <div className="flex justify-center w-full px-2 text-grey-bold">
      <div
        className={`flex flex-col items-center text-center text-xs ${
          isDebugMode ? "pb-2" : "pb-0"
        }`}
      >
        {/* injected git info for dev */}
        <div>v{import.meta.env.VITE_APP_VERSION}</div>
        {isDebugMode && (
          <>
            <div className="pt-2">build:</div>
            <div>{now.toLocaleString()}</div>
            <div className="pt-2">commit:</div>
            {[branch, abbreviatedSha, committerDate].map((a) => (
              <div key={a}>{a}</div>
            ))}
            <div className="pt-2">DB hash:</div>
            <div>{appInfo?.data?.dbhash?.version_num}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default DebugInfo;
